<template>
	<div class="myCoupons">
		<back-to></back-to>
		<section class="myCoupons-top">
			<!-- tab选框 -->
			<div class="myCoupons-top-tab">
				<span :class="current == 0?'actCoupons':''" @click="change(0)">可用</span>
				<span :class="current == 1?'actCoupons':''" @click="change(1)">不可用</span>
			</div>
			<van-list class="myCoupons-list" v-model="loading" :finished="finished" finished-text="没有更多了"
				:immediate-check="false" @load="onLoad">
				<img v-if="list.length == 0" class="myCoupons-list-none" src="../../assets/empty_ico_coupon.png" alt="">
				<ul v-else class="myCoupons-top-list">
					<li v-for="(item, index) in list">
						<div class="myCoupons-top-list-l">
							<span>
								<p>￥</p>
								<font>{{item.money}}</font>
							</span>
							<span>满{{item.fullMoney}}元可用</span>
						</div>
						<div class="myCoupons-top-list-r">
							<span>{{item.name}}</span>
							<span>有效期{{item.startUseDate}}</span>
						</div>
						<img v-if="current == 0 && item.isGet" class="myCoupons-top-list-img"
							src="../../assets/mycoupon_ico_received.png" alt="">
						<font class="coupon-get-btn" v-if="current == 0 && !item.isGet"
							@click="connectGet(item.id,index)">领取</font>
						<img v-if="current == 1" class="myCoupons-top-list-img"
							src="../../assets/mycoupon_ico_Expired.png" alt="">
					</li>
				</ul>
			</van-list>
		</section>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	import {
		Toast
	} from 'vant';
	export default {
		name: "myCoupons",
		components: {
			BackTo
		},
		data() {
			return {
				current: 0,
				loading: false,
				finished: false,
				pageIndex: 1,
				list: []
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.connectList()
		},
		methods: {
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.pageIndex = this.pageIndex + 1
					this.connectList()
				}, 500);
			},
			change(e) {
				if (e == this.current) {
					return
				}
				this.current = e
				window.scrollTo(0, 0)
				this.loading = false
				this.finished = false
				this.pageIndex = 1
				this.connectList(true)
			},
			connectList(e) {
				this.$post(
					this.$activity + '/Coupon/GetCouponList', {
						"pageIndex": this.pageIndex,
						"pageSize": 10,
						"organizationId": this.$organizationId,
						"userId": this.userInfo.userId
					}
				).then(res => {
					if (e) {
						this.list = this.current == 0 ? res.items : res.noItems
					} else {
						this.list = this.list.concat(this.current == 0 ? res.items : res.noItems)
					}
					let listLength = this.current == 0 ? res.items.length : res.noItems.length
					if (listLength < 10) {
						this.finished = true;
					}
				})
			},
			connectGet(id, index) {
				this.$post(
					this.$activity + '/Coupon/UserGetCoupon', {
						"userId": this.userInfo.userId,
						"couponId": id,
						"userName": this.userInfo.wxNick,
						"userPhone": this.userInfo.phone,
						"getType": 0
					}
				).then(res => {
					if (res.isSuccess) {
						this.list[index].isGet = true
						Toast('领取成功');
					} else {
						Toast(res.error);
					}
				})
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
		}
	}
</script>

<style>
	.myCoupons-top {
		width: 100%;
		margin-top: @nav-bar-height;
	}

	.myCoupons-top-tab {
		position: fixed;
		top: @nav-bar-height;
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 98px;
		width: 100%;
		padding: 0 24px;
		box-sizing: border-box;
	}

	.myCoupons-top-tab span {
		flex: 1;
		height: 98px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.actCoupons {
		position: relative;
	}

	.actCoupons::after {
		content: "";
		position: absolute;
		bottom: 10px;
		left: 50%;
		transform: translateX(-50%);
		width: 56px;
		height: 6px;
		background: #FF7A09;
		opacity: 1;
		border-radius: 5px;
	}

	.myCoupons-list {
		padding-top: 100px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}

	.myCoupons-list-none {
		width: 408px;
		height: 315px;
		margin-top: 60px;
	}

	.myCoupons-top-list {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.myCoupons-top-list li {
		height: 150px;
		background: #FFFFFF;
		border-radius: 20px;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		position: relative;
	}

	.myCoupons-top-list-l {
		display: flex;
		flex-direction: column;
		width: 35%;
		height: 100%;
		justify-content: center;
		align-items: center;
		color: #F94C00;
		font-size: 22px;
	}

	.myCoupons-top-list-l span:first-child {
		display: flex;
		align-items: flex-end;
		font-weight: bold;
		font-size: 50px;
	}

	.myCoupons-top-list-l span:first-child p {
		font-size: 28px;
		margin-bottom: 7px;
	}

	.myCoupons-top-list-r {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 60%;
		z-index: 3;
	}

	.myCoupons-top-list-r span:first-child {
		display: inline-block;
		white-space: nowrap;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 30px;
		font-weight: bold;
		color: #333333;
		margin-top: 5px;
	}

	.myCoupons-top-list-r span:last-child {
		margin-top: 16px;
		font-size: 22px;
		color: #999999;
		display: inline-block;
		white-space: nowrap;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.myCoupons-top-list-img {
		position: absolute;
		right: 11px;
		top: 0;
		width: 124px;
		height: 97px;
	}

	.coupon-get-btn {
		width: 110px;
		height: 50px;
		background: #FF7A09;
		border-radius: 25px;
		position: absolute;
		right: 30px;
		top: 46px;
		font-size: 22px;
		color: #FFFFFF;
		text-align: center;
		line-height: 50px;
	}
</style>
